// eslint-disable-next-line
import { cleanObject, isEmptyObject, isEmptyArray } from './Object-functions';
import { ensureValueIsInt } from './Numbers-functions';

export const cleanArray = (array, ensureInt = false) =>
  array.reduce((cleaned, entry) => {
    if (entry && typeof entry === 'object' && !Array.isArray(entry)) {
      const newObject = cleanObject(entry, ensureInt);
      cleaned.push(newObject);
      return cleaned;
    }
    if (entry && typeof entry === 'object' && Array.isArray(entry)) {
      const newArray = cleanArray(entry, ensureInt);
      cleaned.push(newArray);
      return cleaned;
    }
    if (
      !(entry instanceof Date) &&
      (entry === '' ||
        entry === null ||
        entry === undefined ||
        isEmptyObject(entry) ||
        isEmptyArray(entry) ||
        Number.isNaN(entry))
    )
      return cleaned;
    cleaned.push(ensureInt ? ensureValueIsInt(entry) : entry);
    return cleaned;
  }, []);
